import React, {Component, Fragment} from 'react';
import {inject, observer} from 'mobx-react';
import {FormattedMessage, injectIntl} from 'react-intl';
import BaseButton from "../../components/button/BaseButton";
import AvatarIcon from "../../components/AvatarIcon";
import molly from "../../assets/images/avatars/molly.png";


const avatarIconStyle = {
    width: '64px',
    height: '64px',
    minWidth: '64px',
    minHeight: '64px'
};

@inject('guideStore', 'manageStore')
@injectIntl
@observer
class MollyVideoJoyride extends Component {

    componentDidMount() {
    }

    onClick = () => {
        const {guideStore}  = this.props;
        guideStore.next();
    }

    renderContent = () => {
        return <Fragment>
            <AvatarIcon
                iconStyle={avatarIconStyle}
                defaultIconStyle={avatarIconStyle}
                style={{background: 'none'}} icon={molly}
            />

            <div className="joyride-step-content-text-title">
                <FormattedMessage id='joyride.guide.1.step.timeline.molly.1'/>
            </div>
            <div className="joyride-step-content-text">
                <FormattedMessage id='joyride.guide.1.step.timeline.molly.2'/>
            </div>
        </Fragment>;
    }

    render() {
        const {intl: {formatMessage: translate}} = this.props;

        return <div className="joyride-step-content-wrapper molly">
            {this.renderContent()}
            <div className="joyride-step-content-extra">
                <BaseButton onClick={this.onClick} label={translate({id: 'joyride.guide.1.step.timeline.molly.button'})}/>
            </div>
        </div>

    }
}

export default MollyVideoJoyride;